export const events = {
  eventsCardDurationText: 'Durata',
  eventsSearchInputText: 'Cerca',
  eventsRegisteredToEventAlertTitle: 'Registrazione avvenuta con successo',
  eventsUnregisteredToEventAlertTitle: 'Disiscrizione avvenuta con successo',
  eventsExternalRegistrationPopupTitle: 'Registrati',
  eventsExternalRegistrationPopupContent: 'Sei stato registrato con successo?',
  eventsExternalRegistrationNoButtonTitle: 'No',
  eventsExternalRegistrationYesButtonTitle: 'Sì',
  eventsCurtainCopyOptionTitle: 'Copia link',
  eventsCurtainFlagOptionTitle: 'Segnala contenuto',
  eventsLinkCopiedAlertText: 'Link copiato!',
  eventsCurtainAddToCalendOptionTitle: 'Aggiungi al calendario',
  eventdetailsAgendaButtonTitle: 'Agenda',
  eventdetailsOnMapButtonTitle: 'Sulla mappa',
  eventdetailsOnlineLocationTitle: 'Online',
  eventdetailAmountsRegisteredText: 'Partecipanti',
  eventdetailsSeeAllButtonTitle: 'Visualizza tutti',
  eventdetailsRegisteredButtonTitle: 'Registrati',
  eventdetailsRegisterButtonTitle: 'Registrati',
  eventdetailsRegisteredAlertText: 'Registrazione avvenuta con successo',
  eventdetailsUnregisteredAlertText: 'Disiscrizione avvenuta con successo',
  eventdetailsAgendaTitle: 'Agenda',
  eventdetailsSeeAllRegisteredCurtainTitle: 'Utenti registrati',
  eventdetailsSpeakersCurtainTitle: 'Relatori',
  eventdetailsSpeakersSectionTitle: 'Relatori',
  eventdetailsSpeakersSectionSeeAllButtonTitle: 'Visualizza tutti',
  eventdetailsCustomSectionSeeAllButtonTitle: 'Visualizza tutti',
  eventdetailsCurtainCopyOptionTitle: 'Copia link',
  eventdetailsCurtainFlagOptionTitle: 'Segnala contenuto',
  eventsdetailsLinkCopiedAlertText: 'Link copiato!',
  eventdetailsCurtainAddToCalOptionTitle: 'Aggiungi al calendario',
  eventDetailsAddCalendarPopupTitle: 'Calendario',
  eventdetailsAddCalendarPopupContent: 'Aggiungere al calendario?',
  eventdetailsAddCalendarPopupNoButtonTitle: 'No',
  eventdetailsAddCalendarPopupYesButtonTitle: 'Sì',
  eventdetailsSpeakerCurtainCopyOptionTitle: 'Copia link',
  eventdetailsSpeakerCurtainFlagOptionTitle: 'Segnala contenuto',
  eventsdetailsSpeakersLinkCopiedAlertText: 'Link copiato!',
  eventdetailsCustomSectionCurtainCopyOptionTitle: 'Copia link',
  eventdetailsCustomSectionCurtainFlagOptionTitle: 'Segnala contenuto',
  eventsFlag: 'Segnala',
  eventsJoin: 'Partecipa',
  eventdetailsCustomSectionLinkCopiedAlertText: 'Link copiato!',
  eventContentReported: 'Contenuto segnalato',
  eventsError: 'Qualcosa è andato storto!',
  eventdetailsExternalRegistrationPopupContent: 'Sei stato registrato con successo?',
  eventdetailsExternalRegistrationNoButtonTitle: 'No',
  eventdetailsExternalRegistrationYesButtonTitle: 'Sì',
  eventdetailsExternalRegistrationPopupTitle: 'Registrati',
  eventsCardRegisteredButtonTitle: 'Registrati',
  eventsCardRegisterButtonTitle: 'Registrati',
  eventsJoinLink: 'Link per partecipare: [url]{link}[/url][br]',
  eventsGuest: 'Ospite',
  eventsNoSessionInDay: 'Nessun evento in questo giorno.',
  eventsShowUpcomingEvent: 'Mostra prossimo evento'
}
